// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InventoryCardList.css */
.deal-card-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	gap: 12px;
}

.deal-card-wrapper {
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: calc(25% - 12px); /* 4 cards per row */
	max-width: calc(25% - 12px);
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

@media (max-width: 1300px) {
	.deal-card-wrapper {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: calc(33% - 12px); /* 2 cards per row on smaller screens */
		max-width: calc(33% - 12px);
	}
}

@media (max-width: 1000px) {
	.deal-card-wrapper {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: calc(50% - 12px); /* 2 cards per row on smaller screens */
		max-width: calc(50% - 12px);
	}
}

@media (max-width: 576px) {
	.deal-card-wrapper {
		flex: 1 1 100%; /* 2 cards per row on mobile screens */
		max-width: 100%;
	}
}

.card-stats {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/deal-card-list.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;CACC,aAAa;CACb,eAAe;CACf,2BAA2B;CAC3B,SAAS;AACV;;AAEA;CACC,YAA0B;CAA1B,cAA0B;CAA1B,4BAA0B,EAAE,oBAAoB;CAChD,2BAA2B;CAC3B,sBAAsB;CACtB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC;EACC,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,uCAAuC;EACnE,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,uCAAuC;EACnE,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,cAAc,EAAE,sCAAsC;EACtD,eAAe;CAChB;AACD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,YAAY;AACb","sourcesContent":["/* InventoryCardList.css */\n.deal-card-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: flex-start;\n\tgap: 12px;\n}\n\n.deal-card-wrapper {\n\tflex: 1 1 calc(25% - 12px); /* 4 cards per row */\n\tmax-width: calc(25% - 12px);\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n@media (max-width: 1300px) {\n\t.deal-card-wrapper {\n\t\tflex: 1 1 calc(33% - 12px); /* 2 cards per row on smaller screens */\n\t\tmax-width: calc(33% - 12px);\n\t}\n}\n\n@media (max-width: 1000px) {\n\t.deal-card-wrapper {\n\t\tflex: 1 1 calc(50% - 12px); /* 2 cards per row on smaller screens */\n\t\tmax-width: calc(50% - 12px);\n\t}\n}\n\n@media (max-width: 576px) {\n\t.deal-card-wrapper {\n\t\tflex: 1 1 100%; /* 2 cards per row on mobile screens */\n\t\tmax-width: 100%;\n\t}\n}\n\n.card-stats {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
